<template>
  <div class="page">
    <sui-segment class="content" padded attached emphasis="secondary">
      <br>
      <ProjectCards header="Projects" :projects="sortedProjects" />
      <br>
      <br>
      <br>
      <HostCards header="Hosts" :hosts="sortedHosts" />
    </sui-segment>
  </div>
</template>

<script>
  import orderBy from 'lodash/orderBy'
  import {mapGetters} from 'vuex'
  import HostCards from '@/components/cards/Hosts'
  import ProjectCards from '@/components/cards/Projects'

  export default {
    name: 'DashboardView',
    components: {
      HostCards,
      ProjectCards,
    },
    computed: {
      ...mapGetters(['projects', 'hosts']),
      sortedHosts() {
        return orderBy(this.hosts, ['created'], ['desc'])
      },
      sortedProjects() {
        return orderBy(this.projects, ['created'], ['desc'])
      },
    },
  }
</script>

<style scoped>
  .page { display: flex; flex-direction: column; }
  .page > .content { flex: 1; }
</style>
